import { AddressResponse } from "../types/api/common";

export const formatCoordinates = (
  lat: number | undefined,
  lon: number | undefined
): string => {
  if (lat && lon) {
    const latDeg = Math.floor(Math.abs(lat));
    const latMin = Math.floor((Math.abs(lat) - latDeg) * 60);
    const latSec = Math.round(((Math.abs(lat) - latDeg) * 60 - latMin) * 60);
    const latDir = lat >= 0 ? "N" : "S";

    const lonDeg = Math.floor(Math.abs(lon));
    const lonMin = Math.floor((Math.abs(lon) - lonDeg) * 60);
    const lonSec = Math.round(((Math.abs(lon) - lonDeg) * 60 - lonMin) * 60);
    const lonDir = lon >= 0 ? "E" : "W";

    return `${latDeg}°${latMin}'${latSec
      .toString()
      .padStart(2, "0")}"${latDir} ${lonDeg}°${lonMin}'${lonSec
      .toString()
      .padStart(2, "0")}"${lonDir}`;
  }
  return "";
};

export const formatAddress = (address: AddressResponse | undefined): string => {
  if (address) {
    const mainParts = [
      address.postalCode,
      address.country?.title,
      address.region?.title,
      address.city?.title,
      address.district?.title,
      address.village?.title,
      address.street && `${address.street} ул.`,
    ].filter(Boolean);

    const houseParts = [
      address.house && `д. ${address.house}`,
      address.building && `корп. ${address.building}`,
      address.flat && `кв. ${address.flat}`,
    ].filter(Boolean);

    if (houseParts.length > 0) {
      mainParts.push(houseParts.join(" "));
    }

    return mainParts.join(", ");
  }
  return "";
};
